import { ref } from 'vue'
import { backButtonCallback } from '@/router'

const showCollectibleChallengeModal = ref(false)

export const useCollectibleChallengeModal = () => {
  function openCollectibleChallengeModal () {
    backButtonCallback.value = closeCollectibleChallengeModal
    showCollectibleChallengeModal.value = true
  }

  const closeCollectibleChallengeModal = () => {
    backButtonCallback.value = null
    showCollectibleChallengeModal.value = false
  }

  return {
    showCollectibleChallengeModal,
    openCollectibleChallengeModal,
    closeCollectibleChallengeModal,
  }
}